/**
 * @generated SignedSource<<1689ced70e227d8e1417227e7e035a48>>
 * @relayHash e0f69b54f664e53de4e1f4467c4ec99b
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID cdae8374261ac11442227b362b0b41b8f6fb1615e81ed11147d8be72b25d3019

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { srcVirtualAgentPerformanceQuery } from './srcVirtualAgentPerformanceQuery.graphql';

import checkForAiEnabledFF_provider from '@atlassian/jira-relay-provider/src/jsm-va-is-require-ai-enabled.relayprovider';

const node: PreloadableConcreteRequest<srcVirtualAgentPerformanceQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "cdae8374261ac11442227b362b0b41b8f6fb1615e81ed11147d8be72b25d3019",
    "metadata": {},
    "name": "srcVirtualAgentPerformanceQuery",
    "operationKind": "query",
    "text": null,
    "providedVariables": {
      "__relay_internal__pv__atlassianjirarelayprovidersrcjsmvaisrequireaienabledrelayprovider": checkForAiEnabledFF_provider
    }
  }
};

export default node;
